import { isAssetDto } from '@/entities/assets';
import { AssetCategory } from '@/shared/lib/sj-orm';

import { PickDtoFilterMaker } from '../../form-wrapper.types';

export const makeDtoFilter = ({
  categories,
  withCountryFilter,
}: {
  categories?: AssetCategory[];
  withCountryFilter?: boolean;
}): PickDtoFilterMaker => {
  return ({ ctxEntity }) => {
    const country = ctxEntity?.country;

    return (item) => {
      if (!isAssetDto(item)) return false;

      if (withCountryFilter && country && item.country !== country) return false;
      if (categories && !categories.includes(item.category)) return false;

      return true;
    };
  };
};
